import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";

export const EndreAvtaleFeilet = () => {
  const { t } = useTranslation();
  return (
    <Alert data-color="danger">
      <div className="flex flex-col gap-2">
        <Heading level={2} data-size="xs">
          {t("pages.endre.form.feil.feil-posting-tittel")}
        </Heading>
        <Paragraph>
          {t("pages.endre.form.feil.feil-posting-beskrivelse")}
        </Paragraph>
      </div>
    </Alert>
  );
};
